import { Task } from '@admiin-com/ds-graphql';
import { Dialog } from '@mui/material';
import { useState } from 'react';
import { t } from 'i18next';
import { SignModalContent } from './SignModalContent';
import { useGetTask } from '../../hooks/useGetTask/useGetTask';

export interface SignModalProps {
  open: boolean;
  onClose: () => void;
  tasks: Task[];
  onSuccess?: () => void;
  nextButtonText?: string;
}

export const SignModal = ({
  open,
  onClose,
  tasks,
  onSuccess,
  nextButtonText: nextButtonTextProps,
}: SignModalProps) => {
  const [signingIndex, setSigningIndex] = useState(0);

  const onNext = () => {
    if (signingIndex < tasks.length - 1) {
      setSigningIndex(signingIndex + 1);
    }
  };

  const haveNextSignature = signingIndex < tasks.length - 1;

  // Determine button text based on context
  const nextButtonText = haveNextSignature
    ? t('Go to next signature', { ns: 'taskbox' })
    : nextButtonTextProps;
  const taskId = tasks[signingIndex].id;
  const { task: realTask } = useGetTask({
    id: taskId,
    forceRefresh: true,
  });

  return (
    <Dialog open={open} onClose={onClose} fullScreen>
      <SignModalContent
        key={signingIndex}
        task={realTask ?? tasks[signingIndex]}
        onClose={onClose}
        onNext={haveNextSignature ? onNext : onSuccess}
        nextButtonText={nextButtonText}
        timeout={haveNextSignature ? 5000 : 0}
      />
    </Dialog>
  );
};
